import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { fieldTypes } from 'shared/components/DynamicForm/fieldTypes';

import theme from './DynamicFields.scss';

const propTypes = {
  fields: PropTypes.array,
  className: PropTypes.string,
};

const defaultProps = {
  fields: [],
  className: undefined,
};

const formatFieldByType = item => {
  switch (item.type) {
    case fieldTypes.TEXTAREA:
    case fieldTypes.INPUT:
      return item.value;
    case fieldTypes.SELECT:
      return item.elements.find(elem => elem.value === item.value).name;
    default:
      return null;
  }
};

const RenderFields = ({ fields }) => fields.map(item => (
  <div className={ theme.field } key={ item.id }>
    <Choose>
      <When condition={ item.type === fieldTypes.FIELDSET && item.elements.length }>
        <RenderFields fields={ item.elements } />
      </When>
      <Otherwise>
        <div className={ theme.label }>{ item.name }</div>
        <div className={ theme.value }>{ formatFieldByType(item) }</div>
      </Otherwise>
    </Choose>
  </div>
));

RenderFields.propTypes = { fields: PropTypes.object.isRequired };

const DynamicFields = ({
  fields,
  className,
}) => {
  return (
    <div className={ classnames(theme.root, className) }>
      <RenderFields fields={ fields } />
    </div>
  );
};

DynamicFields.propTypes = propTypes;
DynamicFields.defaultProps = defaultProps;

export default DynamicFields;
